var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c("div", [
        _c("div", {
          staticClass: "ma__overlay",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("toggle")
            }
          }
        }),
        _vm._v(" "),
        _c("div", { class: "ma__modalpopup " + _vm.className }, [
          _c(
            "div",
            { staticClass: "ma__content" },
            [
              _c(
                "div",
                {
                  staticClass: "ma__close",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$emit("toggle")
                    }
                  }
                },
                [_c("span", [_vm._v("×")])]
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!./scripts/vue/components/Utilities/Modal.vue?vue&type=template&id=24ea0f7a&
// module id = 130
// module chunks = 3